import { call, put } from "redux-saga/effects";
import axios from "../../axiosConfig";
import { TOAST_SHOW } from "../Actions/ToastAction";
import { GET_HASH_RESULT_SUCCESS, GET_HASH_RESULT_FAILED } from "../Actions/HashActions";

export function* GetHashResultSaga(action:any):unknown{
  
    try {
        const id = action.payload
        const response = yield call(axios.get, `getHash?id=${id}`);

        yield put({ type: GET_HASH_RESULT_SUCCESS, payload: response.data });
      } catch (error) {
        yield put({ type: GET_HASH_RESULT_FAILED});
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
      }
}